export default __webpack_public_path__ + "static/media/self.8f867a7e.jpeg";